import { yieldToMain } from 'assets/core/js/common'
import mobileBottomPanel from 'assets/core/js/module/mobile-bottom-panel'
import checkOfferTrigger from 'assets/core/js/page/product/check-offer-trigger'
import checkoutError from 'assets/core/js/page/product/checkout-error'
import crossSell from 'assets/core/js/page/product/cross-sell'
import favorite from 'assets/core/js/page/product/favorite'
import lastSeen from 'assets/core/js/page/product/last-seen'
import map from 'assets/core/js/page/product/map'

/**
 * Setup components that are core on the product page.
 *
 * It should be called only after the DOM content loaded.
 */
export default (): void => {
  mobileBottomPanel('.dca-mobile-bottompanel__toggle:not([data-panel-target="header-bs-mobile-bottompanel"])')
  checkOfferTrigger()
  checkoutError()

  void (async () => {
    await yieldToMain()
    map()
    favorite()
    crossSell()
    lastSeen()
  })()
}
